<template>
  <Modal :title="title">
    <div>
      {{ message }}
    </div>
    <template #buttons>
      <BaseButton
        v-if="shouldShowInstantEditButton"
        :aria-label="createButtonLabel"
        class="bold"
        :label="createButtonLabel"
        new-design
        @click="openInstantDownloadModal"
      />
      <BaseButton
        aria-label="viewPageText"
        class="confirm"
        color="primary"
        :label="viewPageText"
        new-design
        :to="routeTo"
        @click="close"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "DuplicateMediaItemTranscriptRequestModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    mention: {
      type: Object,
      default: () => ({}),
    },
    stream: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: "",
    },
    shouldShowInstantEditButton: {
      type: Boolean,
    },
    isInstantDownload: {
      type: Boolean,
    },
  },
  computed: {
    isMediaItem() {
      return this.type === "media_item";
    },
    title() {
      if (this.isMediaItem) {
        return this.$t(
          "modals.duplicate_media_item_transcript_modal.media_item_title"
        );
      }

      return this.$t(
        "modals.duplicate_media_item_transcript_modal.transcript_request_title"
      );
    },
    message() {
      if (this.isMediaItem) {
        return this.$t(
          "modals.duplicate_media_item_transcript_modal.media_item_message"
        );
      }

      return this.$t(
        "modals.duplicate_media_item_transcript_modal.transcript_request_message"
      );
    },
    viewPageText() {
      if (this.isMediaItem) {
        return this.$t(
          "modals.duplicate_media_item_transcript_modal.media_item_view_button"
        );
      }

      return this.$t(
        "modals.duplicate_media_item_transcript_modal.transcript_request_view_button"
      );
    },
    createButtonLabel() {
      if (this.isMediaItem) {
        return this.$t(
          "modals.duplicate_media_item_transcript_modal.media_item_create_button"
        );
      }

      return this.$t(
        "modals.duplicate_media_item_transcript_modal.transcript_request_create_button"
      );
    },
    routeTo() {
      return this.isMediaItem
        ? { name: "media-and-transcripts" }
        : "/media-and-transcripts?tab=transcriptRequests";
    },
  },
  methods: {
    close() {
      this.$modals.close("DuplicateMediaItemTranscriptRequestModal");
    },
    openInstantDownloadModal() {
      this.$modals.close("DuplicateMediaItemTranscriptRequestModal");

      const requestModal = this.isMediaItem
        ? "RequestMediaItemModal"
        : "RequestTranscriptItemModal";

      const modal = this.isInstantDownload
        ? "CreateInstantDownloadModal"
        : requestModal;

      this.$modals.open(modal, {
        props: {
          mention: this.mention,
          stream: this.stream,
          type: this.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 325px;
}

.media-item-card {
  width: 300px;
  margin: 0 auto;
  box-shadow: none;
}

.divider {
  border: 0.5px solid $ds-denim-2;
}
</style>
